import { render, staticRenderFns } from "./AccountTypes.vue?vue&type=template&id=70e6fa5f&scoped=true&"
import script from "./AccountTypes.vue?vue&type=script&lang=ts&"
export * from "./AccountTypes.vue?vue&type=script&lang=ts&"
import style0 from "./AccountTypes.vue?vue&type=style&index=0&id=70e6fa5f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e6fa5f",
  null
  
)

export default component.exports